import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Typography,
  Divider,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface AttendanceDataSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const AttendanceDataSection = ({
  formData,
  onFieldChange,
}: AttendanceDataSectionProps) => {
  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Dados do atendimento
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <DatePicker
            label="Data do atend."
            value={formData.dataAtendimento}
            onChange={(date) => onFieldChange("dataAtendimento", date)}
            slotProps={{
              textField: {
                size: "small",
                helperText: "Data do atendimento",
                required: true,
                fullWidth: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Tipo de consulta</InputLabel>
            <Select
              name="tipoConsulta"
              value={formData.tipoConsulta}
              label="Tipo de consulta"
              onChange={handleSelectChange}
            >
              <MenuItem value="1">Primeira Consulta</MenuItem>
              <MenuItem value="2">Retorno</MenuItem>
              <MenuItem value="3">Pré-natal</MenuItem>
              <MenuItem value="4">Por encaminhamento</MenuItem>
            </Select>
            <FormHelperText>Tipo de consulta</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Cobertura Especial</InputLabel>
            <Select
              name="coberturaEspecial"
              value={formData.coberturaEspecial}
              label="Cobertura Especial"
              onChange={handleSelectChange}
            >
              <MenuItem value="">Não se aplica</MenuItem>
              <MenuItem value="1">1 - Acidente do Trabalho</MenuItem>
              <MenuItem value="2">2 - Acidente Automótico DPVAT</MenuItem>
              <MenuItem value="3">3 - Outros acidentes de trânsito</MenuItem>
            </Select>
            <FormHelperText>Tipo de cobertura especial</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Regime Atendimento</InputLabel>
            <Select
              name="regimeAtendimento"
              value={formData.regimeAtendimento}
              label="Regime Atendimento"
              onChange={handleSelectChange}
            >
              <MenuItem value="Telessaúde">Telessaúde</MenuItem>
              <MenuItem value="Ambulatorial">Ambulatorial</MenuItem>
              <MenuItem value="Hospitalar">Hospitalar</MenuItem>
              <MenuItem value="Domiciliar">Domiciliar</MenuItem>
            </Select>
            <FormHelperText>Regime de atendimento</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Saúde Ocupacional</InputLabel>
            <Select
              name="saudeOcupacional"
              value={formData.saudeOcupacional}
              label="Saúde Ocupacional"
              onChange={handleSelectChange}
            >
              <MenuItem value="">Não se aplica</MenuItem>
              <MenuItem value="1">1 - Exame admissional</MenuItem>
              <MenuItem value="2">2 - Exame periódico</MenuItem>
              <MenuItem value="3">3 - Exame demissional</MenuItem>
            </Select>
            <FormHelperText>Tipo de saúde ocupacional</FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};
